import { useCallback, useEffect } from "react";
import { useRouterContext } from "@rotorstudios/fe-modules";

import { PAGE_HOME, PAGE_VEHICLE_SELECTION } from "../fe-modules/Router/static";
import { useDataContext } from "./DataProvider";
import { LOADING_SEQUENCE, SIDEBAR_CONTENT } from "./enums";

const VITE_BUILD_ENV = import.meta.env.VITE_BUILD_ENV;

const useAppLoadingSequence = () => {
  const {
    isInitialDataValidated,
    loadingSequence,
    vehicleData,
    dealershipData,
    userData,
    updateLoadingSequence,
    updateSidebarState,
  } = useDataContext();
  const { gotoPage } = useRouterContext();

  // *******************
  // App Loading Sequence
  // *******************
  // Vehicle data: determines page route - ie. /vehicle-selection vs. /home
  // Dealership data: determines if dealer locator sidebar is visible
  // User Name data: determines if name input sidebar is visible
  // *******************

  const handleLoadingSequence = useCallback(() => {
    // Vehicle Selection
    if (!vehicleData && dealershipData) {
      updateLoadingSequence(LOADING_SEQUENCE.VS);
      gotoPage(PAGE_VEHICLE_SELECTION);
    }
    // Vehicle Selection + dealer locator
    if (!vehicleData && !dealershipData) {
      updateLoadingSequence(LOADING_SEQUENCE.VS_DEALER);
      gotoPage(PAGE_VEHICLE_SELECTION);
      updateSidebarState(SIDEBAR_CONTENT.DEALER_LOCATOR);
    }
    // Home
    if (vehicleData && dealershipData && userData?.skipInput) {
      updateLoadingSequence(LOADING_SEQUENCE.HOME);
      gotoPage(PAGE_HOME);
    }
    // Home + name input
    if (vehicleData && dealershipData && !userData?.skipInput) {
      updateLoadingSequence(LOADING_SEQUENCE.HOME_NAME);
      gotoPage(PAGE_HOME);
      updateSidebarState(SIDEBAR_CONTENT.NAME_INPUT);
    }
    // Home + dealer locator
    if (vehicleData && !dealershipData) {
      updateLoadingSequence(LOADING_SEQUENCE.HOME_DEALER);
      gotoPage(PAGE_HOME);
      updateSidebarState(SIDEBAR_CONTENT.DEALER_LOCATOR);
    }
  }, [
    vehicleData,
    dealershipData,
    userData?.skipInput,
    updateLoadingSequence,
    gotoPage,
    updateSidebarState,
  ]);

  useEffect(() => {
    if (isInitialDataValidated && !loadingSequence) {
      handleLoadingSequence();
    }
  }, [isInitialDataValidated, loadingSequence, handleLoadingSequence]);

  useEffect(() => {
    if (VITE_BUILD_ENV === "dev" && loadingSequence) {
      console.log(">>>> Loading Sequence >>>>", loadingSequence);
    }
  }, [loadingSequence]);
};

export default useAppLoadingSequence;
